import store from "../store";
import { sortImagesByExamDate} from "../helpers/utils";

const allImages = "All Images";
export default class ProofsheetContext {
  constructor(images) {
    this.images = sortImagesByExamDate([...images]);
    this.filteredImages = [...this.images];
    this.currentImages = [];
    this.selectedImages = [];

    this.filterOption = allImages;
    this.currentEye = "";

    this.isDeletingImages = false;

    this.isMarkingImages = false;
  }

  get showAll() {
    return this.filterOption === allImages;
  }

  get allSelected() {
    return this.showAll || this.filteredImages.length == this.selectedImages.length;
  }

  refreshImages(){
    return store.dispatch("loadProofsheetImages");
  }

  setFilterOption(option) {
    this.filterOption = option;
    this.updateFilteredImages();
  }

  setEyeFilter(eye) {
    if (eye === this.currentEye) eye = "";
    this.currentEye = eye;
    this.updateFilteredImages();
  }

  selectImage(image) {
    if (this.selectedImages.includes(image))
      this.selectedImages = this.selectedImages.filter(i => i !== image);
    else
      this.selectedImages.push(image);
  }

  selectAllImages() {
    let visibleImages = this.filteredImages;

    if (this.selectedImages.length === visibleImages.length)
      this.selectedImages = [];
    else 
      this.selectedImages = visibleImages;
  }

  startDeleteImages() {
    this.isDeletingImages = true;
  }

  cancelDeleteImages() {
    this.isDeletingImages = false;
  }

  removeImages(imgSrNos) {
    this.images = this.images.filter(i => !imgSrNos.includes(i.flSrNo));
    this.updateFilteredImages();
  }

  startMarkImages(){
    this.isMarkingImages = true;
  }
  cancelMarkImages(){
    this.isMarkingImages = false;
  }

  updateFilteredImages() {
    let eye = this.currentEye;
    this.filteredImages = this.images
      .filter(i => !eye || i.imgEye === eye || (i.imgEye === "U" && eye === "OU"));
    this.updateSelectedImages();
  }

  updateSelectedImages() {
    this.selectedImages = sortImagesByExamDate(this.selectedImages.filter(i => this.filteredImages.includes(i)));
  }

  setCurrentImages(bounds) {
    let images = this.showAll ? this.filteredImages : this.selectedImages;
    this.currentImages = images.slice(bounds.start, bounds.end);
  }
  
  clearSelectedImages() {
    this.selectedImages = [];
  }
}
